export enum Experiment {
  UseNewPostsCoverDefaults = 'specs.membersAbout.UseNewPostsCoverDefaults',
  EnableAboutContainerStyles = 'specs.membersAbout.EnableAboutContainerStyles',
  UseMigratedEditor3StylesParams = 'specs.membersAbout.UseMigratedEditor3Styles',
  EnableHtmlTagSettings = 'specs.membersAbout.EnableHtmlTagSettings',
  EnableExternalToolbarMobile = 'specs.membersAbout.EnableExternalToolbarMobile',
}
